import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Block } from '@abaco/crop-plan-module/src/modules/crop-plan-module/models/Block';
import { PlotSeed } from '@abaco/crop-plan-module/src/modules/crop-plan-module/models/Seed';
import { Variety } from "./models/Variety";

export default class GrapesDashboardVuexModule extends AbacoVuexModule {

    @State() curVariety!: Variety | null;
    @State() curBlock!: Block | null;

}

